<template>
  <div>
       <EventDetails v-bind:id="id"></EventDetails>    
  </div>
</template>

<script>
import { db } from '../services/firebase';

export default {
  name: 'Event',
  props: ['id']
}

</script>